import { loadStripe } from '@stripe/stripe-js';

// Helper to get the Stripe key from various possible sources
const getStripeKey = () => {
  // Check for the key in different possible locations
  console.log("process.env,", process.env);
  const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 
                   window.env?.REACT_APP_STRIPE_PUBLIC_KEY ||
                   process.env.REACT_APP_STRIPE_KEY;
  
  if (!stripeKey) {
    console.warn('Stripe public key is missing in environment');
    return null;
  }
  
  return stripeKey;
};

// Initialize Stripe with the public key
const stripeKey = getStripeKey();
let stripePromise = null;

if (stripeKey) {
  try {
    stripePromise = loadStripe(stripeKey);
  } catch (e) {
    console.error('Error initializing Stripe:', e);
    stripePromise = Promise.reject(e);
  }
} else {
  stripePromise = Promise.reject(new Error('Stripe public key is missing'));
}

export const getStripePromise = () => stripePromise;

export const isStripeConfigured = () => {
  return !!getStripeKey();
}; 